/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Miespacio from './Miespacio';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as paginaActions from '../../actions/paginaActions';
import * as pagosActions from '../../actions/pagosActions';

import * as inscripcionActions from '../../actions/inscripcionActions';
import * as cursoopinionActions from '../../actions/cursoopinionActions';
import {Auth} from 'aws-amplify';
import * as cursoActions from '../../actions/cursoActions';
import { withAuthenticator } from '@aws-amplify/ui-react'
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import * as menuActions from '../../actions/menuActions'; 
import * as userActions from '../../actions/userActions';
import ModalMetodosPago from './ModalMetodosPago';
import ModalComentario from './ModalComentario';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import moment from 'moment';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as usuariocursoActions from '../../actions/usuariocursoActions';

import {usuarioActualMiEspacio, validaApiToken} from '../../util';
 

import {getMargenes, getMargenesBlack} from '../../util/';



class ManageMiespacio extends React.Component {
    constructor(props, context) {
		
		super(props, context);
       
   
        
        
        this.state={
            modalMetodosPago:false,
            modalComentario:false,
            errors:{},
            strings:{},
            showActivos:true,
            filtrosCombo:{},
            permisos:{},
            pagosLista:[],
            pagoLiquidar:{id:0}, 
            cursosPrevios:[],
            cursosActuales: [],
            constancias:[],
            datosVaico:{descripcion:null, calificacion:5},
            datos:{descripcion:null, calificacion:5},
            cursoPago:{
                price:0,
                descripcion:null
            },
            pago:{},
            showDeposito:0,
            cursoIdComentario:0
		};
	}
    
    
    /*
    usuarioActual=( componente, pageOrigen, requerido)=>{
    
	  Auth.currentSession()
          .then((session) => {
               
            var idTokenExpire = session.getIdToken().getExpiration();
            var refreshToken = session.getRefreshToken();
            var currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
              Auth.currentAuthenticatedUser()
                .then((res) => {
                  res.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                      Auth.signOut()
                    } else {
                        this.setUsuario(componente, pageOrigen, session);
                      //config.headers.Authorization = "Bearer " + data.getIdToken().getJwtToken();
                      //resolve(config);
                    }
                  });
                });
            } else {
                 
                 this.setUsuario(componente, pageOrigen, session);
              //config.headers.Authorization = "Bearer " + session.getIdToken().getJwtToken();
              //resolve(config);
            }
          })
          .catch(() => {
            // No logged-in user: don't set auth header
             if(requerido==true){
                    //componente.props.history.push('/');
             }
         componente.props.userActions.addUser(null);
            
          });
    }


   setUsuario=( componente, pageOrigen, session)=>{
    let user={
                "idToken":session.getIdToken().getJwtToken()
            }
            componente.props.userActions.addUser(user);
         
            const userInfo={username:session.getIdToken().decodePayload()["cognito:username"], ...session.attributes};
            componente.setState({"userInfo": userInfo});
            
             let pageInfo={
                page:pageOrigen,
                idioma:componente.props.idioma    
            };
       
       
            this.props.menuActions.getMenu(user).then( ()=>{

                this.props.paginaActions.getInfo(pageInfo, user).then( pageInfoResponse=>{

                    if(pageInfoResponse.completarRegistro==1){
                           //this.props.history.push('/completar');
                       }
                       this.setState({"permisos":pageInfoResponse.permisos,
                                     "strings":Object.assign({}, pageInfoResponse.strings)});
                })
                .catch(error=>{
                  toastr.error(error);
                }); 

               this.props.cursoActions.getCursosActuales(user).then( cursosActuales=>{
                       this.setState({"cursosActuales":cursosActuales});
                })
                .catch(error=>{
                    toastr.error(error);
                }); 



                this.props.usuarioActions.getFotoPerfil(user).then( ()=>{

                })
                .catch(error=>{
                    toastr.error(error);
                }); 

            })
            .catch(error=>{
                toastr.error(error);
            }); 
            
             
}*/
	componentDidMount(){
       
        usuarioActualMiEspacio(this, "Miespacio",true).then( (usuario)=>{
           window.scrollTo(0, 0);
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
            
            
           
          
            
       })
        .catch(error=>{
          toastr.error(error);
        }); 
      // this.checkUser();
      //this.usuarioActual(this, "",true);
		
        
                
               
        
        
         
	}
    
    showModalMetodosPago=()=>{
        
        this.setState({"modalMetodosPago":true})
    }
    
    colesModalMetodosPago=()=>{
        this.setState({"modalMetodosPago":false})
    }
    
    
    showModalComentario=(cursoIdComentario, comentario)=>{
        
        if(comentario>0){
            validaApiToken(this).then( (userToken)=>{
                this.props.cursoopinionActions.getCursoOpinion(comentario, userToken).then((comentario) => {
                    this.setState({datos:comentario});
                });
            }).catch(error=>{
                toastr.error(error);
            }); 
        }
        
        this.setState({"modalComentario":true, cursoIdComentario:cursoIdComentario})
    }
    
    closeModalComentario=()=>{
        let cursoIdComentario=this.state.cursoIdComentario;
        cursoIdComentario=0;
        this.setState({"modalComentario":false,cursoIdComentario:cursoIdComentario, datos:this.state.datosVaico})
        
    }
    
    init=()=>{
        
                
                this.props.cursoActions.getCursosActuales(this.props.user).then( cursosActuales=>{
                       this.setState({"cursosActuales":cursosActuales});
                })
                .catch(error=>{
                    toastr.error(error);
                });
        
                
        
             
    }
    
    handleChange=(id)=>{
        
        //console.log("pago:"+id);
        let pagoLiquidar = this.state.pagoLiquidar;
        let cursoPago = this.state.cursoPago;
        let pagoLiquidarIndex = this.state.pagosLista.findIndex(pagos=>pagos.id == id);
        pagoLiquidar = this.state.pagosLista[pagoLiquidarIndex];
        cursoPago.price = Number(pagoLiquidar.montoPago).toFixed(2);
        //cursoPago.price = 10;
        cursoPago.descripcion = pagoLiquidar.curso;
        cursoPago.reference_id = pagoLiquidar.id;
        cursoPago.idInscripcion = pagoLiquidar.inscripcionId;
        
        this.setState({pagoLiquidar:pagoLiquidar, cursoPago:cursoPago});
        
    }
    
    
    handleApprove = (orderID, order)=>{
            let pago = this.state.pago;
            pago.id =this.state.pagoLiquidar.id
            pago.referencia = order.purchase_units[0].payments.captures[0].id;
            pago.cadena = Object.assign({},order);
            pago.cadena=JSON.stringify(pago.cadena);
            //pago.fechaPago = new moment(order.update_time).format('DD/MM/YYYY');
            pago.pagado=1;
            
            
           validaApiToken(this).then( (userToken)=>{
                this.props.pagosActions.save(pago, userToken).then(() => {
                    toastr.success("Pago registrado!!!.");
                    
                     this.props.pagosActions.getPagosUsuario(userToken).then((pagos)=>{
                            this.setState({pagosLista:pagos});
                        }) 
                            .catch(error=>{ 
                              toastr.error(error); 
                        });
                    
                })
                .catch(error=>{
                    toastr.error(error);
                });
            }).catch(error=>{
                toastr.error(error);
            });
            
    }
    
    
    onShowDeposito=()=>{
        
        let showDeposito = this.state.showDeposito;
        
        if(showDeposito==0){
            showDeposito=1;
        }else{
            showDeposito=0;
        }
        
        
        this.setState({showDeposito:showDeposito});
    }
    
    
    handleChange=(event, data)=> {

     
        
        let datos = this.state.datos;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		datos[field[0]]= value;
		else{
             if(!datos[field[0]]){
                    datos[field[0]]={}
                }
			datos[field[0]][field[1]]= value;
		}
        
        //console.log(datos);
		
        this.setState({"datos": datos});
    }
    
    
    onChangeRate=(event, data)=>{
        
        let datos = this.state.datos;
        datos.calificacion = data.rating;
        this.setState({"datos": datos});

    }
    
    
    onSave=(event)=>{
        event.preventDefault();
        let datos = this.state.datos;
        datos.idCurso = this.state.cursoIdComentario;

        
         validaApiToken(this).then( (userToken)=>{
            console.log(userToken);
            this.props.cursoopinionActions.saveComentarioUsuario(this.state.datos, userToken).then((comentarios) => {
                toastr.success("Comentario guardado!!!.");

                let constancias = this.state.constancias;
                let constanciasIndex = this.state.constancias.findIndex(constancia=>constancia.idCurso == this.state.cursoIdComentario);
                console.log(constanciasIndex);
                console.log(constancias[constanciasIndex]);
                constancias[constanciasIndex].comentario=comentarios.id;
                this.setState({constancias:constancias});
                this.closeModalComentario();
            });
             
             
         }).catch(error=>{
            toastr.error(error);
        }); 
        
    }

    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
		return (
            
            <Segment style={margenes} >
                  
                <Miespacio
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                     permisos={this.state.permisos}
                    cursosActuales={this.state.cursosActuales}
                    cursosPrevios={this.state.cursosPrevios}
                    constancias={this.state.constancias}
                    userInfo={this.state.userInfo}
                    prueba={this.state.prueba}
                    showModalMetodosPago={this.showModalMetodosPago}
                    showModalComentario={this.showModalComentario}
                    pagosLista={this.state.pagosLista}
                    handleChangePago={this.handleChange}
                    pagoLiquidar={this.state.pagoLiquidar}
                    cursoPago={this.state.cursoPago}
                    handleApprove={this.handleApprove}
                    onShowDeposito={this.onShowDeposito}
                    showDeposito={this.state.showDeposito}
  
                />
            
                <ModalMetodosPago
                showModal={this.state.modalMetodosPago} 
                closeModal={this.colesModalMetodosPago}
            />
            
                <ModalComentario
                strings={this.props.strings}
                showModal={this.state.modalComentario} 
                closeModal={this.closeModalComentario}
                datos={this.state.datos}
                onChange={this.handleChange}
                onChangeRate={this.onChangeRate}
                saveComentario={this.onSave}
                
            />
            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {   
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        strings:state.strings,
        idioma:state.idioma,
        menu:state.menu,
        user:state.user
    }

}

function mapDispatchToProps(dispatch){

	return {  
        pagosActions: bindActionCreators(pagosActions, dispatch),
        menuActions: bindActionCreators(menuActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
        inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        cursoopinionActions: bindActionCreators(cursoopinionActions, dispatch),
        usuariocursoActions: bindActionCreators(usuariocursoActions, dispatch),
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withAuthenticator(ManageMiespacio));